import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Frown } from 'lucide-react';
export function PainSection() {
  return <section className="py-20 bg-white relative" data-id="element-96">
      <div className="container mx-auto px-4" data-id="element-97">
        <div className="max-w-3xl mx-auto" data-id="element-98">
          {/* The Hook: Mirror Moment */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="mb-16" data-id="element-99">
            <div className="flex items-center gap-2 mb-4" data-id="element-100">
              <span className="text-4xl" data-id="element-101">🚗</span>
              <h2 className="text-3xl md:text-4xl font-bold text-espresso font-serif" data-id="element-102">
                Son las 6:15 PM. Estás en el tráfico...
              </h2>
            </div>

            <div className="prose prose-lg text-gray-700 leading-relaxed" data-id="element-103">
              <p className="mb-4" data-id="element-104">
                Acabas de terminar una jornada agotadora. Estás atrapada en la
                I-95 (o la 405, o la I-10) y solo piensas en una cosa:
                <span className="font-bold text-terracotta block text-xl mt-2" data-id="element-105">
                  "¿Qué voy a hacer de cenar?"
                </span>
              </p>
              <p data-id="element-106">
                Llegas a casa, abres el refrigerador y solo ves recipientes
                vacíos o ingredientes que tardarían horas en prepararse.
                Suspiras. Sacas el teléfono y pides Uber Eats.
              </p>
              <div className="bg-red-50 border-l-4 border-red-400 p-4 my-6 rounded-r-lg" data-id="element-107">
                <p className="font-medium text-red-800 m-0" data-id="element-108">
                  Otros $55 a la basura. Otra comida alta en sodio que te dejará
                  inflamada y sin energía mañana.
                </p>
              </div>
            </div>
          </motion.div>

          {/* The Conflict */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-cream rounded-2xl p-8 md:p-10 border border-stone-200 shadow-sm" data-id="element-109">
            <div className="flex items-start gap-4" data-id="element-110">
              <div className="bg-terracotta/10 p-3 rounded-full hidden md:block" data-id="element-111">
                <Frown className="h-6 w-6 text-terracotta" data-id="element-112" />
              </div>
              <div data-id="element-113">
                <h3 className="text-2xl font-bold text-espresso mb-4 font-serif" data-id="element-114">
                  Por qué las soluciones viejas fallan
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-115">
                  Has intentado buscar recetas de "Meal Prep" en internet. Pero
                  seamos sinceras: las guías americanas de{' '}
                  <span className="italic" data-id="element-116">"Chicken & Broccoli"</span> son
                  aburridas.
                </p>
                <p className="text-lg font-medium text-forest" data-id="element-117">
                  Nosotras somos latinas. Necesitamos el sazón, el sofrito, la
                  variedad. 🥑
                </p>
                <p className="text-gray-700 mt-4" data-id="element-118">
                  No queremos comer lo mismo 5 días seguidos como si fuera una
                  dieta de gimnasio. Necesitamos comida que abrace el alma.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}